window.onload = function() {
  if (window.innerWidth <= 991) {
      var productDiscription = document.getElementById('m-1676516790679');
      var productInfo = document.getElementById('r-1685971000335');
      var leftColumn = document.getElementById('c-1676512646536');
      var rightColumn = document.getElementById('c-1676512646511');

      // remove rightP1 from rightColumn and insert before leftP2
      rightColumn.removeChild(productInfo);
      productDiscription.parentNode.insertBefore(productInfo, productDiscription);
  }
};